import React, { Component, useState, useEffect } from 'react';
import { 
  Container, 
  Row, 
  Col,  
  Collapse,
  Card, 
  CardBody, 
  CardHeader, 
  Button
} from 'reactstrap';
import { QuickLinks, PDFDownload, Accordion } from '../../CommonComponents';
import { pldtConfig } from '../../config';

function NewsSnippetTemplate ( {title, date, link, oldlink} ){
    return (
      <Row noGutters >
        <Col xs="12" lg="8">
          <div className="d-flex align-items-start align-top">
            <div className="ml-2">
                <h5 className="text-uppercase text-lightgrey" dangerouslySetInnerHTML={{__html: title}}/>
                {
                    date !== "" && date !== undefined
                    ?
                    <p className="text-lightgrey" dangerouslySetInnerHTML={{__html: date}}/>
                    :
                    <p>&nbsp;</p>
                }
            </div>
          </div>
        </Col>
        <Col xs="12" lg="4" className="text-lg-right">
          {
            oldlink !== undefined && oldlink !== ""
          ?
            <Button className="mt-2 mb-3 mb-lg-0" download href={oldlink}>Read More</Button>
          :
            <Button className="mt-2 mb-3 mb-lg-0" download href={pldtConfig.appDomain + link}>Read More</Button>
          }
        </Col>
      </Row>
    )
}

export function NewsSnippet( {newsdata} ){
    return(
        <div className="pdf-download">
            {
                newsdata.map((news, index) => {
                    return(
                        <NewsSnippetTemplate title={news.title} date={news.date} link={news.link} oldlink={news.oldlink} key={index}/>
                    )
                })
            }
        </div>
    )
}

export class IRGeneralPDFAccordion extends Component{
    constructor(props) {
      super(props);
      this.state = {
        collapse: window.location.hash.substring(1),
      };
      this.toggle = this.toggle.bind(this);
    }

    decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }

    nohash () {
      let url = window.location.href;
      let hash = window.location.hash;
      let index_of_hash = url.indexOf(hash) || url.length;
      let hashless_url = url.substring(0, index_of_hash);
      return hashless_url;
    }
  
    toggle = collapse => () => {
      window.history.replaceState({}, '', this.nohash() + "#" + collapse);
        this.setState({ 
            collapse: this.state.collapse === collapse ? "" : collapse,
        }); 
    }
  
    toggleButton (state, condition){
      if (state === condition){
        return (
            <span className="position-absolute accordion-arrows">-</span>
        )
      }
      else{
        return (
            <span className="position-absolute accordion-arrows">+</span>
        )
      }
    }
  
    render(){   

    let pdfcategories = [...new Set(this.props.accordion.map(pdf => pdf.category))];


    if (this.props.accordion < 1) {
        return <div>Loading...</div>
    } else {
      return (
        <div>
          {
            pdfcategories.map((pdfcategory) => {
              let categoryFilteredData = this.props.accordion.filter(pdfDataCategory => pdfDataCategory.category === pdfcategory);
              let trimpdfcategory = pdfcategory.trim();
              let htmldecodedpdfcategory = this.decodeHtml(trimpdfcategory);
              let categorylc = htmldecodedpdfcategory.replace(/\s-\s/g,"-").replace(/[^a-z0-9 -]/gi,"").replace(/\s+/g, '-').toLowerCase();
              switch (this.props.type){
                case "newsdata": 
                  return (
                    <Card key={encodeURIComponent(categorylc)} id={encodeURIComponent(categorylc)} className="mb-4">
                      <CardHeader onClick={this.toggle(`${encodeURIComponent(categorylc)}`)} data-event={encodeURIComponent(categorylc)} style={{cursor: 'pointer'}}>
                          <h4 className="mb-0 text-uppercase" dangerouslySetInnerHTML={{__html: trimpdfcategory}}/>
                          {this.toggleButton(this.state.collapse, `${encodeURIComponent(categorylc)}`)}
                      </CardHeader>
                      <Collapse isOpen={this.state.collapse === `${encodeURIComponent(categorylc)}`}>
                          <CardBody>
                              <NewsSnippet newsdata={categoryFilteredData} cms="no"/>
                          </CardBody>
                      </Collapse>
                    </Card>
                  )
                break;
                default:
                return (
                  <Card key={encodeURIComponent(categorylc)} id={encodeURIComponent(categorylc)} className=" mb-4">
                    <CardHeader onClick={this.toggle(`${encodeURIComponent(categorylc)}`)} data-event={encodeURIComponent(categorylc)} style={{cursor: 'pointer'}}>
                        <h4 className="mb-0 text-uppercase" dangerouslySetInnerHTML={{__html: trimpdfcategory}}/>
                        {this.toggleButton(this.state.collapse, `${encodeURIComponent(categorylc)}`)}
                    </CardHeader>
                    <Collapse isOpen={this.state.collapse === `${encodeURIComponent(categorylc)}`}>
                        <CardBody>
                            <PDFDownload pdfs={categoryFilteredData} cms="no"/>
                        </CardBody>
                    </Collapse>
                  </Card>
                )   
              }                        
            })
          }
        </div>
      )};
    }
}

export function IRPDFMainContent ({apiendpoint}) {
    const [prData, setPRData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
  
    useEffect(() => {
      const url = pldtConfig.apiUrl + apiendpoint;
  
      const fetchData = async () => {
          try {
              const response = await fetch(url);
              const json = await response.json();

              if (json.length === 0) {
                  setIsError(true);
              } else {
                setPRData(json);
              }
              setIsLoading(false);
          } catch (error) {
              setIsError(true);
              console.log("error", error);
          }
      };
  
      fetchData();
    }, []);
  
    if (isLoading) {
      return(
        <p>Loading...</p>
      )
    }
  
    if (isError) {
        return(
            <p>No data...</p>
        )
    }
    
      return (
          <Container fluid className="pt-5 page-accordion" style={{backgroundColor: '#f5f5f5'}} >
              <Row style={{backgroundColor: '#f2f2f2'}}>
                  <Col className="px-3 px-lg-5">   
                    <IRGeneralPDFAccordion accordion={prData} type="newsdata"/>
                  </Col>
              </Row>
          </Container>
      )
  }

  const subnavmenu = [
    {
      "menu": "BOARD MEETING/ STOCKHOLDERS' RELATED DISCLOSURES",
      "link": "/investor-relations/press-releases-and-disclosures"
    },
    {
      "menu": "FINANCIAL RESULTS",
      "link": "/investor-relations/press-releases-and-disclosures/financial-results"
    },
    {
      "menu": "NEWS CLARIFICATIONS FILED WITH PSE",
      "link": "/investor-relations/press-releases-and-disclosures/news-clarifications-filed-with-pse"
    },
    {
      "menu": "ORGANIZATIONAL ANNOUNCEMENTS",
      "link": "/investor-relations/press-releases-and-disclosures/organizational-announcements"
    },
    {
      "menu": "SUSTAINABILITY",
      "link": "/investor-relations/press-releases-and-disclosures/sustainability"
    },
    {
      "menu": "VOYAGER (PAYMAYA)",
      "link": "/investor-relations/press-releases-and-disclosures/voyager-paymaya"
    },
    {
      "menu": "ACQUISITIONS, PARTNERSHIP AND OTHERS",
      "link": "/investor-relations/press-releases-and-disclosures/acquisitions-partnerships-and-others"
    },
    {
      "menu": "SHARE BUY-BACK DISCLOSURES",
      "link": "/investor-relations/press-releases-and-disclosures/share-buy-back-disclosures"
    }
  ]

  const shareholderssubnavmenu = [
    {
      "menu": "SHAREHOLDER NEWS",
      "link": "/investor-relations/shareholder-information/latest-shareholders-news"
    },
    {
      "menu": "SHAREHOLDING STRUCTURE",
      "link": "/investor-relations/shareholder-information/shareholding-structure"
    },
    {
      "menu": "DIVIDEND INFO",
      "link": "/investor-relations/shareholder-information/dividend-info"
    },
    {
      "menu": "TOP 100 STOCKHOLDERS",
      "link": "/investor-relations/shareholder-information/top-100-stockholders"
    },
    {
      "menu": "PUBLIC OWNERSHIP REPORT",
      "link": "/investor-relations/shareholder-information/public-ownership-report"
    },
    {
      "menu": "BENEFICIAL OWNERSHIP",
      "link": "/investor-relations/shareholder-information/beneficial-ownership"
    },
    {
      "menu": "TRANSFER AGENTS",
      "link": "/investor-relations/shareholder-information/transfer-agents"
    }
  ]

  const quicklinksBG = {
    backgroundColor: '#800000', 
    paddingTop: '50px', 
    height: '50px'
  }

  export function DropdownSubnav (){
    return (
      <section style={quicklinksBG}><QuickLinks label="Please select topic" quicklinkmenu={subnavmenu}/></section>
    )
  }

  export function ShareholderDropdownSubnav (){
    return (
      <section style={quicklinksBG}><QuickLinks label="Please select topic" quicklinkmenu={shareholderssubnavmenu}/></section>
    )
  }

  export const contactsection = [
    {
      "icon": "/images/pldt-corpwebsite-homepage-talktous.png",
      "title": "TALK TO US",
      "copy": "If you want to consult one of our Investor Relations members, contact us here.",
      "btncopy": "CONTACT US",
      "link": "/investor-relations/analysts-and-investors-contact"
    },
    {
      "icon": "/images/corporategovernance/pldt-corpwebsite-corporategovernance-aboutpldt.png",
      "title": "ABOUT PLDT",
      "copy": "Through the culture of innovation, we strive to enable the nation with our customer-focused solutions that empower and unleash every Filipino’s infinite potential.",
      "btncopy": "LEARN MORE",
      "link": "/about-us"
    }
]
  export function IRArticleMainContent({apiendpoint}) {
    const [prData, setPRData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
  
    useEffect(() => {
      const url = pldtConfig.apiUrl + apiendpoint;
  
      const fetchData = async () => {
          try {
              const response = await fetch(url);
              const json = await response.json();
              // console.log(json);
  
              if (json.length === 0) {
                  setIsError(true);
              } else {
                setPRData(json);
              }
              setIsLoading(false);
          } catch (error) {
              setIsError(true);
              console.log("error", error);
          }
      };
  
      fetchData();
    }, []);
  
    if (isLoading) {
      return(
        <p>Loading...</p>
      )
    }
  
    if (isError) {
        return(
            <p>No data...</p>
        )
    }
  
    return(
        <Container fluid className="pt-5 page-accordion" style={{backgroundColor: '#f5f5f5'}} id="dividendinfo">
          <Row style={{backgroundColor: '#f2f2f2'}}>
            <Col className="px-3 px-lg-5">   
              <Accordion accordion={prData} />
            </Col>
          </Row>
        </Container>
    )
  }